import { render, staticRenderFns } from "./Table.vue?vue&type=template&id=f0df3b8e&"
import script from "./Table.vue?vue&type=script&lang=js&"
export * from "./Table.vue?vue&type=script&lang=js&"
import style0 from "./Table.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Table.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QInput,QIcon,QToggle,QSpace,QBtn,QTooltip,QBadge,QBtnGroup,QBtnDropdown,QList,QItem,QItemSection,QItemLabel,QTable,QTr,QTh,QTd,QCheckbox,QCard,QCardSection,QPagination,QSpinnerGears,QInnerLoading,QField,ClosePopup} from 'quasar'
component.options.components = Object.assign({QInput,QIcon,QToggle,QSpace,QBtn,QTooltip,QBadge,QBtnGroup,QBtnDropdown,QList,QItem,QItemSection,QItemLabel,QTable,QTr,QTh,QTd,QCheckbox,QCard,QCardSection,QPagination,QSpinnerGears,QInnerLoading,QField}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
